import { action } from "@ember/object";
import { service } from "@ember/service";
import GroupIndexController from "discourse/controllers/group/index";
import { bind } from "discourse/lib/decorators";
import { i18n } from "discourse-i18n";

export default class CircleMembersController extends GroupIndexController {
  @service dialog;

  circleMembershipType = "members";

  @action
  actOnSelection(selection, actionId) {
    if (!selection || selection.length === 0) {
      return;
    }

    switch (actionId) {
      case "removeMembers":
        const owners = selection.filter((user) => user.owner);
        if (owners.length > 0) {
          this.dialog.alert(
            i18n(
              `discourse_circles.circle.${this.circleMembershipType}.cannot_remove_owner`,
              {
                usernames: owners.map((user) => user.username).join(", "),
                count: owners.length,
              }
            )
          );
          return;
        }
        break;

      case "makeOwners":
      case "removeOwners":
        // feature disabled for Circles groups
        return;
    }

    super.actOnSelection(...arguments);
  }

  @bind
  isBulkSelected(user) {
    return this.bulkSelection?.some((u) => u.id === user.id);
  }

  @action
  removeMember(user) {
    if (user.owner) {
      this.dialog.alert(
        i18n(
          `discourse_circles.circle.${this.circleMembershipType}.cannot_remove_owner`,
          { usernames: user.username, count: 1 }
        )
      );
      return;
    }

    super.removeMember(...arguments);
  }

  @action
  makeOwner() {
    // feature disabled for Circles groups
  }

  @action
  removeOwner() {
    // feature disabled for Circles groups
  }

  // overriding because we need to keep the bulk selection if the user navigates to other tabs
  @action
  selectMember(member, e) {
    this.set("bulkSelection", this.bulkSelection || []);

    // to prevent duplicates in the bulk selection we remove the user if it's already there
    // comparing the id. this is necessary because pushObject won't deduplicate if the user
    // navigated to another tab and then returned as the objects will be different because
    // the data may have been reloaded
    const selection = this.bulkSelection.filter((u) => u.id !== member.id);

    // if the checkbox is checked we add the user to the bulk selection
    // otherwise we already remover the user from the bulk selection in the step above
    if (e.target.checked) {
      selection.push(member);
    }

    this.set("bulkSelection", selection);
  }
}
